import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrapApp() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}

function googleMapsLoaded() {
  let maps = google.maps as any;

  if (maps.importLibrary) {
    Promise.all([
      maps.importLibrary('drawing'),
      maps.importLibrary('places'),
      maps.importLibrary('geometry')
    ]).then(bootstrapApp).catch(bootstrapApp);
  } else {
    bootstrapApp();
  }
}

function loadGoogleMaps() {
  let googleMapsUrl = 'https://maps.googleapis.com/maps/api/js?v=3.64&key=AIzaSyAsTOvB-a_4lrKmwxGCYv01QYj9yZjriNI&libraries=drawing,places,geometry&loading=async&callback=googleMapsLoaded';
  let loginCountry = sessionStorage.getItem('loginCountry') || '';

  if (loginCountry.trim().toUpperCase() === 'CAN') {
    googleMapsUrl += '&region=CA';
  } else {
    googleMapsUrl += '&region=US';
  }

  let script = document.createElement('script');
  script.src = googleMapsUrl;
  script.async = true;
  script.defer = true;
  script.onerror = bootstrapApp;
  window['googleMapsLoaded'] = googleMapsLoaded;
  document.head.appendChild(script);
}

let hasLogin = sessionStorage.getItem('customerID') !== null;
let isPublicOnHold = window.location.pathname.toLowerCase().indexOf('/onholdp') !== -1;

if (hasLogin || isPublicOnHold) {
  loadGoogleMaps();
} else {
  bootstrapApp();
}
